export interface IOwners {
    data: IDirectoryRecordOwner[];
    getOwnersLoading?: boolean;
}

export interface IDirectoryRecordOwner {
    id: string;
    value: string;
}

export enum IOwnersActionTypes {
    GET_OWNERS = "GET_OWNERS",
    GET_OWNERS_LOADING = "GET_OWNERS_LOADING",
}

export interface IOwners {
    data: IDirectoryRecordOwner[];
    getOwnersLoading?: boolean;
}
